// Fixed categorical order (dataviz rule: assign in order, never cycle). Five slots are defined
// as tokens; more series than that fold into "Other" or small multiples at the call site.
import type { ChartConfig } from "../components/chart";

export const SERIES_COLORS = [
  "var(--chart-1)",
  "var(--chart-2)",
  "var(--chart-3)",
  "var(--chart-4)",
  "var(--chart-5)",
] as const;

export const MAX_SERIES = SERIES_COLORS.length;

export type SeriesSpec = {
  /** Data key in each row. */
  key: string;
  label: string;
};

/** Builds a ChartConfig with each series pinned to its slot by position in `series`. */
export function seriesConfig(series: readonly SeriesSpec[]): ChartConfig {
  if (series.length > MAX_SERIES) {
    throw new Error(
      `at most ${MAX_SERIES} series per chart; fold the rest into "Other" or use small multiples`,
    );
  }
  const config: ChartConfig = {};
  series.forEach((s, i) => {
    config[s.key] = { label: s.label, color: SERIES_COLORS[i] ?? SERIES_COLORS[0] };
  });
  return config;
}
